import { IDeviceFullInfoState } from './deviceFullInfoContext';
import {
	DeviceFullInfoActionTypes,
	TDeviceFullInfoAction,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoActions';

export const deviceFullInfoReducer = (
	state: IDeviceFullInfoState,
	action: TDeviceFullInfoAction,
): IDeviceFullInfoState => {
	switch (action.type) {
		case DeviceFullInfoActionTypes.SET_DEVICE_FOR_FULL_INFO:
			return {
				...state,
				deviceForFullInfo: action.payload.deviceForFullInfo,
			};
		case DeviceFullInfoActionTypes.SET_DROPBOX_PUSH_FILE_TYPE:
			return {
				...state,
				selectedDropboxPushFileType: action.payload.selectedDropboxPushFileType,
			};
		case DeviceFullInfoActionTypes.SET_DROPBOX_PUSH_MESSAGE:
			return {
				...state,
				selectedDropboxPushMessage: action.payload.selectedDropboxPushMessage,
			};
		case DeviceFullInfoActionTypes.CHANGE_DROPBOX_PUSH_PARAMS:
			return {
				...state,
				dropboxPushParams: action.payload.dropboxPushParams,
			};
		case DeviceFullInfoActionTypes.RESET_DROPBOX_PUSH_FIELDS:
			return {
				...state,
				selectedDropboxPushFileType: null,
				selectedDropboxPushMessage: null,
				dropboxPushParams: '',
			};
		case DeviceFullInfoActionTypes.RESET_MODAL_STATE:
			return {
				...state,
				dataForPush: null,
				isBackupEnabled: true,
				isDeactivateDeviceWithRemoveContent: false,
				isDeactivateDeviceWithResetRestaurant: false,
			};
		case DeviceFullInfoActionTypes.SET_DATA_FOR_PUSH:
			return {
				...state,
				dataForPush: action.payload.dataForPush,
			};
		case DeviceFullInfoActionTypes.SWITCH_BACKUP_ENABLED:
			return {
				...state,
				isBackupEnabled: action.payload.isBackupEnabled,
				isDeactivateDeviceWithRemoveContent: action.payload.isDeactivateDeviceWithRemoveContent,
				isDeactivateDeviceWithResetRestaurant: action.payload.isDeactivateDeviceWithResetRestaurant,
			};
		case DeviceFullInfoActionTypes.SET_DEACTIVATE_DEVICE_WITH_REMOVE_CONTENT:
			return {
				...state,
				isDeactivateDeviceWithRemoveContent: action.payload.isDeactivateDeviceWithRemoveContent,
			};
		case DeviceFullInfoActionTypes.SET_DEACTIVATE_DEVICE_WITH_RESET_RESTAURANT:
			return {
				...state,
				isDeactivateDeviceWithResetRestaurant: action.payload.isDeactivateDeviceWithResetRestaurant,
			};
		case DeviceFullInfoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
